
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import CatalogListGrid from "../../../common/catalog/CatalogListGrid";
import CatalogListSection from "../../../common/catalog/CatalogListSection";
import CatalogEmptyState from "../../../common/catalog/CatalogEmptyState";
import { getCatalogEmptyCopy } from "../../../common/catalog/catalogEmptyCopy";
import { fetchCatalogListPage } from "../../../common/catalog/fetchCatalogListPage";
import Paginator from "../../../common/paginator/Paginator";
import Skeleton from "../../../common/loading/Skeleton";
import Workshop from "../../common/workshop/Workshop";

export default function WorkshopSection({ isDesktop, query, expertiseId }) {
	const navigate = useNavigate();
	const [workshops, setWorkshops] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchWorkshops(1);
	}, []);

	useEffect(() => {
		if (page !== 1) {
			setPage(1);
		}
		fetchWorkshops(1);
	}, [query, expertiseId]);

	useEffect(() => {
		fetchWorkshops(page);
	}, [page]);

	function fetchWorkshops(currentPage) {
		if (isLoading) {
			return;
		}
		setIsLoading(true);
		let queryParam = query ? query : '';
		let expertiseIdParam = expertiseId ? expertiseId : '';
		fetchCatalogListPage({
			fetchPage: (params) => api.workshopSearch(params),
			baseParams: {
				query: queryParam,
				expertise_id: expertiseIdParam,
			},
			displayPage: currentPage,
			listKey: "workshops",
		})
			.then(({ items, maxPage }) => {
				setWorkshops(items);
				setMaxPageNum(maxPage);
				setIsLoading(false);
			})
			.catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	const emptyCopy = getCatalogEmptyCopy({
		itemSingular: "کارگاه",
		query,
		hasExtraFilter: Boolean(expertiseId),
	});

	const pagination =
		workshops.length >= 1 && maxPageNum >= 2 ? (
			<Paginator
				currentPage={page}
				maxPageNum={maxPageNum}
				isLoading={isLoading}
				onChange={(newPage) => {
					setPage(newPage);
				}}
			/>
		) : null;

	return (
		<CatalogListSection pagination={pagination}>
			{workshops.length === 0 && isLoading && (
				<Skeleton variant="grid" type="workshop" count={8} />
			)}
			{workshops.length >= 1 && (
				<CatalogListGrid isDesktop={isDesktop}>
					{workshops.map((workshop) => (
						<Workshop key={workshop.id} workshop={workshop} />
					))}
				</CatalogListGrid>
			)}
			{workshops.length === 0 && !isLoading && !errorMessage && (
				<CatalogEmptyState
					message={emptyCopy.message}
					hint={emptyCopy.hint}
					actionLabel={emptyCopy.showClear ? "نمایش همهٔ کارگاه‌ها" : undefined}
					onAction={
						emptyCopy.showClear
							? () => navigate("/workshop_list/")
							: undefined
					}
				/>
			)}
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</CatalogListSection>
	)
}
